var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container card-deck-div"
  }, [_c('h1', [_vm._v("Latest Events")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-deck row"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": require("./../Events/Cleaniness/Cleaniness-pics/bright.jpg"),
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-block btn-large",
    attrs: {
      "tag": "button",
      "to": {
        path: '/events'
      },
      "exact": ""
    }
  }, [_vm._v("Show More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": require("./Home-pics/mas-main.jpg"),
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-block btn-large",
    attrs: {
      "tag": "button",
      "to": {
        path: '/events#mas'
      },
      "exact": ""
    }
  }, [_vm._v("Show More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": require("./../Events/Wad/Wad-pics/kids-books.jpg"),
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-block",
    attrs: {
      "tag": "button",
      "to": {
        path: '/events#wad'
      },
      "exact": ""
    }
  }, [_vm._v("Show More")])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Clean India Mission")]), _vm._v(" "), _c('p', {
    staticClass: "card-text d-none d-sm-block"
  }, [_vm._v("We went above and beyond to fully support the Swachh Bharat Abhiyan introduced by PM Modi.")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Organised on 23 Feb 2017.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Mahila Aarogya Samiti")]), _vm._v(" "), _c('p', {
    staticClass: "card-text d-none d-sm-block"
  }, [_vm._v(" A group of local women who focus on helping other women in their respective local areas to raise issues faced in the under-privileged sections of the society.")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("An ongoing campaign.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("World AIDS Day")]), _vm._v(" "), _c('p', {
    staticClass: "card-text d-none d-sm-block"
  }, [_vm._v("We organised this event to provide books and food to the children living in the slums near Birla Ghat (Haridwar) while spreading awareness about AIDS with the locals.")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Carried out on 1 December 2013.")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6954350a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/LatestEvents.vue
// module id = hA7s
// module chunks = 0